import React, { useState, useEffect } from 'react'
import { Panel, Message, Col, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import InputForm from '../../../components/forms/input/InputForm'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import pathname from '../../../constants/pathname'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import notification from '../../../utils/notification'
import EditFormDescriptionWidget from '../dynamicForm/EditFormDescriptionWidget'
import { saveSettingFormResultsReport } from '../../../redux/actions/subProjectFormSetting'
import ViewSettingFormListWidget from '../dynamicForm/ViewSettingFormListWidget'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function ResultsReportSettingWidget(props) {
  // const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [notiMsg, setNotiMsg] = useState()
  const [isRefash, setIsRefash] = useState(false)

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSettingFormResultsReport(formId, request)
      if (response?.forms?.resultsReport) {
        setFormSchema(response.forms.resultsReport)
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setNotiMsg({
          type: 'error',
          msg: DEFAULT_ERR_MSG,
        })
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)
      setNotiMsg({
        type: 'error',
        msg: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    formSchema?.outcomes?.forEach((item) => {
      let collectData = data[`${formSchema?.inputForm?.dataToCollect?.name}:${item.id}`] || null
      let howtoCollectData =
        data[`${formSchema?.inputForm?.dataCollection?.name}:${item.id}`] || null

      values.push({
        id: item.id,
        collectData: collectData,
        howtoCollectData: howtoCollectData,
      })
    })

    let request = {
      id: formSchema.id,
      detail: data.detail || null,
      note: data.note || null,
      values: values,
      descValues: data.descSettingValues || [],
      descDelIds: data.descDelIds || [],
    }
    // console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {!isRefash && (
        <>
          {formSchema?.descriptionSetting && (
            <EditFormDescriptionWidget
              schema={formSchema.descriptionSetting}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          )}

          {formSchema?.inputForm?.detail && (
            <InputForm
              schema={formSchema.inputForm.detail}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              rows={4}
              componentClass="textarea"
            />
          )}

          {formSchema?.outcomes?.map((e) => {
            return (
              <Panel header={`ผลลัพธ์ : ${e.outcome}`} collapsible defaultExpanded>
                <div style={{ marginTop: -10, marginBottom: 20 }}>
                  {/* <div style={{ marginTop: -10, marginBottom: 10 }}>{e.label}</div> */}
                  <Row style={{ marginTop: 10, marginLeft: 20 }}>
                    <Col>
                      <strong>ตัวชี้วัด</strong>
                    </Col>
                    <Col>
                      <ViewSettingFormListWidget
                        objects={e.indicator}
                        // header={'ตัวชี้วัด'}
                        // collapsible
                        // defaultExpanded
                        // bordered
                      />
                    </Col>
                  </Row>

                  {formSchema?.inputForm?.dataToCollect && (
                    <Row style={{ marginLeft: 20 }}>
                      <CKEditorFrom
                        schema={formSchema?.inputForm?.dataToCollect}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        value={e.dataToCollect}
                        name={`${formSchema.inputForm.dataToCollect.name}:${e.id}`}
                      />
                    </Row>
                  )}

                  {formSchema?.inputForm?.dataCollection && (
                    <Row style={{ marginTop: 10, marginLeft: 20 }}>
                      <CKEditorFrom
                        schema={formSchema.inputForm.dataCollection}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        value={e.dataCollection}
                        name={`${formSchema.inputForm.dataCollection.name}:${e.id}`}
                      />
                    </Row>
                  )}
                </div>
              </Panel>
            )
          })}

          {formSchema?.inputForm?.note && (
            <>
              <hr />
              <CKEditorFrom
                schema={formSchema.inputForm.note}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </>
          )}
        </>
      )}

      <hr />
      {notiMsg && (
        <Message
          closable
          showIcon
          type={notiMsg.type}
          description={notiMsg.msg}
          onClose={() => setNotiMsg('')}
          style={{ marginBottom: 10 }}
        />
      )}
      <div className="right">
        <ViewButton
          style={{
            marginRight: 10,
            marginBottom: 10,
          }}
          onClick={() => {
            window.open(`${pathname.subProjectNew.proposal.resultsReport}?preView`, '_blank')
          }}
          children={'แสดงตัวอย่าง'}
        />
        <SaveButton
          children={SAVE + formSchema.buttonText || ''}
          disabled={isLoading}
          onClick={handleSubmit(onSubmit)}
        />
        <CancelButton children={CANCEL} onClick={onRefash} />
      </div>

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
